// extracted by mini-css-extract-plugin
export var card = "tireCard-module--card---ukcZ";
export var info = "tireCard-module--info--e-CPk";
export var snowContainer = "tireCard-module--snowContainer--eQqbh";
export var snow = "tireCard-module--snow--j+u6g";
export var magimage = "tireCard-module--magimage--m2n48";
export var ply = "tireCard-module--ply--Gvr7c";
export var sku = "tireCard-module--sku--26xAC";
export var price = "tireCard-module--price--MxMAO";
export var slowshow = "tireCard-module--slowshow--Y95+I";